import React from 'react';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import PldPage from '../pages/PldPage';
import { useTranslation } from 'react-i18next';

export const Pld = () => {
  const { t, i18n } = useTranslation();

  return (
    <Layout backgroundimage={Back1} actionDemo={false}>
      <SEO
        title={t('Software PLD para la Prevención del Lavado de Dinero')}
        description={t('Cumple con normativas CNBV y refuerza la seguridad con nuestro módulo avanzado de prevención de lavado de dinero.')}
        bolImage={false}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/anti-money-laundering' : 'pld'}`}
        hreflang={[
          { url: "https://dynamicore.io/pld", lang: "es" },
          { url: "https://dynamicore.io/en/anti-money-laundering", lang: "en-us" }
        ]}
      />
      <PldPage/>
    </Layout>
  )
}
